import { merge } from 'lodash'
import {
  defaultSystemCode,
  defaultUserAddress,
  exists,
  MailAddress,
  MailAddressFromJSON,
  OldAddress,
  OldAddressFromJSON,
  OldName,
  OldNameFromJSON,
  SystemCode,
  SystemCodeFromJSON,
  UserAddress,
  UserAddressFromJSON,
  UserOtherContact,
  UserOtherContactFromJSON,
  UserPhone,
  UserPhoneFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface UserPersonal {
  name: string
  nameKana: string
  birthday: string
  birthdayJapaneseSymbol: SystemCode
  gender: SystemCode
  userAddress: UserAddress
  phones: UserPhone[]
  mailAddresses: MailAddress[]
  workType: SystemCode
  disability: boolean
  guardian: string
  guardianKana: string
  userFamilyId: number | null
  otherContacts: UserOtherContact[]
  oldNames: OldName[]
  oldAddresses: OldAddress[]
  studentGrade: SystemCode
  studentClass: SystemCode
  studentNumber: string
}

export function UserPersonalFromJSON(json: any): UserPersonal {
  return {
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    birthday: exists(json, 'birthday') ? dateToPlainFormat(json.birthday) : '',
    birthdayJapaneseSymbol: defaultBirthdayJapaneseSymbol(),
    gender: exists(json, 'gender')
      ? SystemCodeFromJSON(json.gender)
      : defaultSystemCode(),
    userAddress: UserAddressFromJSON(json.user_address),
    phones: (json.phones as any[]).map(UserPhoneFromJSON),
    mailAddresses: (json.mail_addresses as any[]).map(MailAddressFromJSON),
    workType: exists(json, 'work_type')
      ? SystemCodeFromJSON(json.work_type)
      : defaultSystemCode(),
    disability: json.disability,
    guardian: exists(json, 'guardian') ? json.guardian : '',
    guardianKana: exists(json, 'guardian_kana') ? json.guardian_kana : '',
    userFamilyId: json.user_family_id,
    otherContacts: (json.other_contacts as any[]).map(UserOtherContactFromJSON),
    oldNames: (json.old_names as any[]).map(OldNameFromJSON),
    oldAddresses: (json.old_addresses as any[]).map(OldAddressFromJSON),
    studentGrade: exists(json, 'student_grade')
      ? SystemCodeFromJSON(json.student_grade)
      : defaultSystemCode(),
    studentClass: exists(json, 'student_class')
      ? SystemCodeFromJSON(json.student_class)
      : defaultSystemCode(),
    studentNumber: exists(json, 'student_number') ? json.student_number : ''
  }
}

export const defaultBirthdayJapaneseSymbol = (): SystemCode => {
  return merge(defaultSystemCode(), {
    name: '西暦',
    shortName: '西暦'
  })
}

export const defaultUserPersonal = (): UserPersonal => ({
  name: '',
  nameKana: '',
  birthday: '',
  birthdayJapaneseSymbol: defaultBirthdayJapaneseSymbol(),
  gender: defaultSystemCode(),
  userAddress: defaultUserAddress(),
  phones: [],
  mailAddresses: [],
  workType: defaultSystemCode(),
  disability: false,
  guardian: '',
  guardianKana: '',
  userFamilyId: null,
  otherContacts: [],
  oldNames: [],
  oldAddresses: [],
  studentGrade: defaultSystemCode(),
  studentClass: defaultSystemCode(),
  studentNumber: ''
})
